/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {arrayToMap, Module} from "@intuitionrobotics/ts-common";
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {DB_UnitMetadata} from "@app/ir-q-app-common/types/unit-config";
import {CareCenterMetadata} from "@app/app-shared/api";
import {Clause_Where} from "@intuitionrobotics/firebase";
import {DB_Patient} from "@app/app-shared/patient";


export class MetadataModule_Class extends Module {
    public subGroupMap: Record<string, DB_Patient[]> | null = null;

    constructor() {
        super("MetadataModule");
    }

    private async queryMetadataImpl(query: Clause_Where<DB_UnitMetadata<any>>) {
        return XhrHttpModule
            .createRequest<CareCenterMetadata>(HttpMethod.POST, "query-metadata")
            .setRelativeUrl("/v1/metadata/query")
            .setLabel(`Querying metadata`)
            .setJsonBody(query)
            .executeSync()
    }

    public async getSubGroups(patients: DB_Patient[]): Promise<Record<string, DB_Patient[]>> {
        if (this.subGroupMap !== null)
            return this.subGroupMap

        const filteredMetadata = await this.queryMetadataImpl({ dataKey: "sub_user_group" })

        const patientMap = arrayToMap(patients, p => p.unitId);
        filteredMetadata.forEach(({ unitId, data }) => {
            const patient = patientMap[unitId];
            if (!patient)
                return;

            if (!this.subGroupMap)
                this.subGroupMap = {};

            if (!this.subGroupMap[data])
                this.subGroupMap[data] = [];
            this.subGroupMap[data].push(patient);
        });

        if (!this.subGroupMap)
            this.subGroupMap = {};

        return this.subGroupMap;
    }

}

export const MetadataModule = new MetadataModule_Class();

